import React from 'react';

import { useAiAssistant } from './AiAssistantContext';
import { ContentShell } from './styles';

// Reserves right-side space for the open AI assistant drawer so the main app
// content reflows into the remaining width instead of hiding behind the panel.
// The header stays full-width (rendered outside this shell); only the content
// below it is wrapped here.
export function AiAssistantContentShell({ children }: { children: React.ReactNode }) {
  const { isOpen, panelWidth, isResizing } = useAiAssistant();

  return (
    <ContentShell $open={isOpen} $resizing={isResizing} $width={panelWidth}>
      {children}
    </ContentShell>
  );
}
